import React from "react"
import { CardTitle, Table } from "reactstrap"
import BarChart from "./barchartv2"
import { useTranslation } from "react-i18next"
import IconifyIcon from "components/Shared/IconifyIcon"
import { useSelector } from "react-redux"
import { layoutModeTypes } from "../../../constants/layout"
import { hasValidChartData } from "../dashboardChartOptions"
import Colors from "constants/Colors"

const LanguagesDashboardv2 = ({ dashboardData }) => {
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  const {
    t,
    i18n: { language },
  } = useTranslation()

  var barChartColor = ["#00778B"]

  const languages =
    dashboardData?.language_stats
      ?.map(lang => ({
        name: language === "sa" ? lang?.language_name_ar : lang?.language_name,
        count: lang?.count,
      }))
      ?.sort((a, b) => b.count - a.count) || []

  const data = {
    labels: languages?.map(lang => lang.name),

    datasets: [
      {
        label: "Languages",
        backgroundColor: barChartColor[0],
        borderColor: barChartColor[0],
        borderWidth: 1,
        hoverBackgroundColor: barChartColor[1],
        hoverBorderColor: barChartColor[1],
        data: languages.map(lang => lang.count),
        color:
          layoutMode === layoutModeTypes.LIGHT ? Colors.black : Colors.white,
      },
    ],
  }

  const option = {
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
      // datalabels: {
      //   color: "white",
      //   font: {
      //     weight: "bold",
      //     size: 10,
      //   },
      //   formatter: (value, context) => {
      //     const total = context.dataset.data.reduce((acc, num) => acc + num, 0)
      //     const percentage = ((value / total) * 100).toFixed(1) // Convert to percentage
      //     return `${percentage}%` // Display as percentage
      //   },
      // },
      // tooltip: {
      //   callbacks: {
      //     label: context => {
      //       const dataset = context.dataset.data
      //       const total = dataset.reduce((acc, num) => acc + num, 0)
      //       const value = dataset[context.dataIndex]
      //       const percentage = ((value / total) * 100).toFixed(1)
      //       return `${value} (${percentage}%)` // Show count + percentage
      //     },
      //   },
      // },
    },
    scales: {
      x: {
        barPercentage: 0.4,
        grid: {
          drawBorder: false,
          drawOnChartArea: false, // Hide vertical grid lines
          drawTicks: false,
        },
        ticks: {
          color:
            layoutMode === layoutModeTypes.LIGHT ? Colors.black : Colors.white, // X-axis labels color
        },
      },
      y: {
        display: false,
      },
    },
  }

  const totalCount = languages?.reduce((sum, item) => sum + item.count, 0)
  return (
    <>
      <div className="g_between align-items-start">
        <div>
          <div className="d-flex gap-1">
            <IconifyIcon
              icon="clarity:language-line"
              style={{
                color:
                  layoutMode === layoutModeTypes.LIGHT
                    ? Colors.primary
                    : Colors.primaryLight,
              }}
            />
            <h4
              style={{
                fontWeight: "700",
                color:
                  layoutMode === layoutModeTypes.LIGHT
                    ? Colors.black
                    : Colors.white,
              }}
            >
              {t("Languages")}
            </h4>
          </div>
          <p
            style={{
              fontSize: "12px",
              color:
                layoutMode === layoutModeTypes.LIGHT
                  ? Colors.mutedBlue
                  : Colors.white,
            }}
          >
            {t("Number of applicants based on languages.")}
          </p>
        </div>
      </div>
      <div className="my-2">
        <div className="ltr">
          {hasValidChartData(data) ? (
            <BarChart data={data} options={option} />
          ) : (
            <div className="g_center h-75">
              <h5 className="pt-5">{t("No Data Available")}</h5>
            </div>
          )}
        </div>
      </div>
      {hasValidChartData(data) && (
        <Table bordered className="language_table mt-3">
          <tbody>
            <tr>
              <th
                scope="row"
                className={"text-capitalize"}
                style={{
                  color:
                    layoutMode === layoutModeTypes.LIGHT
                      ? Colors.black
                      : Colors.white,
                }}
              >
                {t("Languages")}
              </th>
              <th
                scope="row"
                className={"text-capitalize"}
                style={{
                  color:
                    layoutMode === layoutModeTypes.LIGHT
                      ? Colors.black
                      : Colors.white,
                }}
              >
                {t("Count")}
              </th>
              <th
                scope="row"
                className={"text-capitalize"}
                style={{
                  color:
                    layoutMode === layoutModeTypes.LIGHT
                      ? Colors.black
                      : Colors.white,
                }}
              >
                {t("%")}
              </th>
            </tr>
            {languages?.map(item => (
              <tr key={item?.name}>
                <th
                  scope="row"
                  className={"text-capitalize"}
                  style={{
                    color:
                      layoutMode === layoutModeTypes.LIGHT
                        ? Colors.black
                        : Colors.white,
                  }}
                >
                  {item?.name}
                </th>
                <td
                  style={{
                    color:
                      layoutMode === layoutModeTypes.LIGHT
                        ? Colors.black
                        : Colors.white,
                  }}
                >
                  {item?.count?.toLocaleString()}
                </td>
                <td
                  style={{
                    color:
                      layoutMode === layoutModeTypes.LIGHT
                        ? Colors.black
                        : Colors.white,
                  }}
                >
                  {((item.count / totalCount) * 100).toFixed(1)}%
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  )
}

export default LanguagesDashboardv2
